import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ListItemText from '@mui/material/ListItemText';
import {
  Alert,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  LinearProgress,
  MenuItem,
  OutlinedInput,
  Pagination,
  Paper,
  Select,
  Stack,
  Typography,
} from '@mui/material';

import { useGetNewsQuery } from '../slices/historyApiSlice';
import News from '../components/News';
import PeriodPicker from '../components/PeriodPicker';

// const Item = styled(Paper)(({ theme }) => ({
//   backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
//   ...theme.typography.body2,
//   padding: theme.spacing(0),
//   textAlign: 'center',
//   color: theme.palette.text.secondary,
// }));

const NewsList = ({ section }) => {
  const { userInfo, date1mem, date2mem } = useSelector((state) => state.auth);
  const [allEvents, setAllEvents] = useState([]);
  const [selectedEvents, setSelectedEvents] = useState('');
  const [allStages, setAllStages] = useState([]);
  const [selectedStages, setSelectedStages] = useState('');
  const [page, setPage] = React.useState(1);
  const [showFilters] = useState(false);

  const { data, refetch, isLoading, isError, error, isFetching } =
    useGetNewsQuery({
      stages: [selectedStages],
      events: [selectedEvents],
      page,
      date1: showFilters ? date1mem : '',
      date2: showFilters ? date2mem : '',
      section,
    });

  const handleChangePage = (event, value) => {
    setPage(value);
  };
  useEffect(() => {
    refetch();
  }, [page, refetch]);

  const handleChangeStagesSingle = (event) => {
    setSelectedStages(event.target.value);
  };

  const handleChangeEventsSingle = (event) => {
    setSelectedEvents(event.target.value);
  };

  const handleSetFilter = (event, stage) => {
    if (stage === selectedStages) {
      setSelectedEvents('ALL');
      setSelectedStages('');
    } else {
      setSelectedEvents(event);
      setSelectedStages(stage);
    }
  };

  // const handleShowFilter = () => {
  //   if (showFilters) {
  //     setSelectedEvents('');
  //     setSelectedStages('');
  //     setPage(1);
  //     setShowFilters(false);
  //   } else {
  //     setShowFilters(true);
  //   }
  // };

  useEffect(() => {
    if (data) {
      if (Array.isArray(data?.allEvents)) {
        setAllEvents(data.allEvents);
      }
      if (Array.isArray(data?.allStages)) {
        setAllStages(data.allStages);
      }
      if (data?.page) {
        setPage(data.page);
      }
    }
  }, [data]);

  return (
    <>
      {isLoading ? (
        <CircularProgress />
      ) : isError ? (
        <Alert severity='warning'>{error?.data?.message || error.error}</Alert>
      ) : (
        <>
          {showFilters && (
            <Paper elevation={3} sx={{ p: 1 }}>
              <Grid
                container
                rowSpacing={1}
                columnSpacing={{ xs: 0, sm: 0, md: 1 }}
              >
                <Grid item sm={12} md={12} xs={12}>
                  <Grid
                    container
                    rowSpacing={1}
                    columnSpacing={{ xs: 1, sm: 1, md: 1 }}
                  >
                    <Grid item sm={6} md={6} xs={6} sx={{ mb: 0 }}>
                      {Array.isArray(allEvents) && allEvents.length > 0 && (
                        <FormControl sx={{ width: '100%' }}>
                          <InputLabel id='multiple-checkbox-selector1-label'>
                            События
                          </InputLabel>
                          <Select
                            labelId='multiple-checkbox-selector1-label'
                            id='multiple-checkbox-selector1'
                            value={selectedEvents}
                            onChange={handleChangeEventsSingle}
                            input={<OutlinedInput label='События' />}
                          >
                            {allEvents?.map((item) => (
                              <MenuItem key={item.event} value={item.event}>
                                <ListItemText primary={item.desc} />
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                    </Grid>
                    <Grid item sm={6} md={6} xs={6} sx={{ mb: 0 }}>
                      {selectedEvents === 'CLOSE_STAGE' && (
                        <FormControl sx={{ width: '100%' }}>
                          <InputLabel id='multiple-checkbox-selector2-label'>
                            Этапы
                          </InputLabel>
                          <Select
                            labelId='multiple-checkbox-selector2-label'
                            id='multiple-checkbox-selector2'
                            // multiple
                            value={selectedStages}
                            onChange={handleChangeStagesSingle}
                            input={<OutlinedInput label='Этапы' />}
                          >
                            {allStages?.map((item) => (
                              <MenuItem key={item?._id} value={item?._id}>
                                <ListItemText primary={item?.title} />
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item sm={12} md={12} xs={12}>
                  <PeriodPicker />
                </Grid>
              </Grid>
              {Array.isArray(data?.stagesStat) &&
                data?.stagesStat.length > 0 && (
                  <Grid
                    container
                    spacing={{ xs: 1, md: 1 }}
                    columns={{ xs: 12, sm: 12, md: 12 }}
                  >
                    {data?.stagesStat.map((stage, index) => (
                      <Grid item xs={3} sm={3} md={3} key={stage?._id || index}>
                        <Button
                          variant={
                            selectedStages === stage?._id ? 'outlined' : 'text'
                          }
                          endIcon={stage?.count}
                          size='small'
                          onClick={() =>
                            handleSetFilter('CLOSE_STAGE', stage?._id)
                          }
                        >
                          {stage?.shortName}:
                        </Button>
                      </Grid>
                    ))}
                  </Grid>
                )}
            </Paper>
          )}

          {/* <Stack spacing={2} sx={{ mt: 1 }}>
            {data?.history?.length === 0 ? (
              <></>
            ) : (
              // <p>Новостей нет</p>
              <Stack
                direction='row'
                spacing={0}
                justifyContent={'space-between'}
              >
                <Pagination
                  count={data?.pages}
                  page={page}
                  shape='rounded'
                  onChange={handleChangePage}
                />

              </Stack>
            )}
          </Stack> */}
          {isFetching && <LinearProgress />}

          {data?.history?.length > 0 && (
            <>
              <Divider />
              <Typography sx={{ m: 1, mt: 2 }} variant='h6' gutterBottom>
                Новости
              </Typography>
              <Stack spacing={2} sx={{ mt: 1 }}>
                <Stack
                  direction='row'
                  spacing={0}
                  justifyContent={'space-between'}
                >
                  <Pagination
                    count={data?.pages}
                    page={page}
                    shape='rounded'
                    onChange={handleChangePage}
                  />
                  {/* <Item>
                  <IconButton aria-label='settings' onClick={handleShowFilter}>
                    <FilterAltIcon />
                  </IconButton>
                </Item> */}
                </Stack>
              </Stack>
              <News
                items={data?.history}
                stages={data?.allStages}
                isAdmin={['admin', 'Люция'].includes(userInfo?.login)}
              />
              <Stack spacing={2}>
                {data?.history?.length > 0 && (
                  <Pagination
                    count={data?.pages}
                    page={page}
                    shape='rounded'
                    onChange={handleChangePage}
                  />
                )}
              </Stack>
            </>
          )}
        </>
      )}
    </>
  );
};

export default NewsList;
